(function () {
  function initCarousel(root) {
    const frame = root.querySelector('.bewo-ingredients__frame');
    if (!frame || frame.dataset.carouselReady === 'true') return;
    frame.dataset.carouselReady = 'true';

    const items = Array.from(frame.querySelectorAll('.bewo-ingredients__item'));
    if (!items.length) return;

    const prev = frame.querySelector('.bewo-ingredients__arrow--prev');
    const next = frame.querySelector('.bewo-ingredients__arrow--next');
    const dotsRoot = frame.querySelector('.bewo-ingredients__dots');
    const swipeTarget = frame.querySelector('.bewo-ingredients__grid') || frame;

    let active = items.findIndex((item) => item.classList.contains('is-active'));
    if (active < 0) active = 0;

    const dots = [];

    if (dotsRoot) {
      dotsRoot.innerHTML = '';
      items.forEach((_, index) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'bewo-ingredients__dot';
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-label', `Ingrediente ${index + 1}`);
        dot.addEventListener('click', () => {
          active = index;
          render();
        });
        dotsRoot.appendChild(dot);
        dots.push(dot);
      });
    }

    const render = () => {
      items.forEach((item, index) => {
        item.classList.toggle('is-active', index === active);
      });

      dots.forEach((dot, index) => {
        dot.classList.toggle('is-active', index === active);
        dot.setAttribute('aria-selected', index === active ? 'true' : 'false');
      });
    };

    const step = (delta) => {
      active = (active + delta + items.length) % items.length;
      render();
    };

    prev?.addEventListener('click', () => step(-1));
    next?.addEventListener('click', () => step(1));

    let touchStartX = 0;
    let touchStartY = 0;

    swipeTarget.addEventListener(
      'touchstart',
      (event) => {
        touchStartX = event.changedTouches[0].screenX;
        touchStartY = event.changedTouches[0].screenY;
      },
      { passive: true }
    );

    swipeTarget.addEventListener(
      'touchend',
      (event) => {
        const deltaX = event.changedTouches[0].screenX - touchStartX;
        const deltaY = event.changedTouches[0].screenY - touchStartY;

        if (Math.abs(deltaX) < 48 || Math.abs(deltaX) < Math.abs(deltaY)) return;

        step(deltaX < 0 ? 1 : -1);
      },
      { passive: true }
    );

    render();
  }

  function initAll() {
    document.querySelectorAll('[data-bewo-ingredients]').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector('[data-bewo-ingredients]');
    if (root) initCarousel(root);
  });
})();
